import * as React from 'react';
import { IgcSwitchComponent as Component } from 'igniteui-webcomponents';
import type { IgcSwitchComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Similar to a checkbox, a switch controls the state of a single setting on or off.
 * @slot  - The switch label.
 * @fires igcChange - Emitted when the control's checked state changes.
 * @csspart base - The base wrapper of the switch.
 * @csspart control - The switch input element.
 * @csspart thumb - The position indicator of the switch.
 * @csspart label - The switch label.
 * @class
 */
export const IgrSwitch = /* @__PURE__ */ createComponent({
  tagName: 'igc-switch',
  displayName: 'IgrSwitch',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<IgcSwitchComponentEventMap['igcChange']>,
  },
});

export type IgrSwitch = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSwitchModule = Component;
